import leftsidebarpopulate from '/src/lib/custom/js/leftsidebarpopulate.js';
// This file only loads for resume page
let arrowVisibilityTimeout;
let alreadyLoaded = false;

function resumePageEvents() {
    // Open the sidebar
   async function openSidebar(e) {
        const resumeSidebar = document.getElementById('resumeSidebar');
        const leftSidebarScrollableDiv = document.getElementById('leftSidebarScrollableDiv');
        const dynamicContentArea = document.getElementById('dynamicContentArea');
        var leftSideContainerTop = document.getElementById("leftSideContainerTop");
        if (leftSideContainerTop) leftSideContainerTop.style.visibility = "visible";
        if (resumeSidebar && dynamicContentArea && leftSidebarScrollableDiv) {
            resumeSidebar.classList.add('open');
            if (!alreadyLoaded){
                console.log ("Loading in openSidebar");
                dynamicContentArea.innerHTML = leftSidebarScrollableDiv.innerHTML;
                leftsidebarpopulate.init();
                // jobSearchEvents.jobSearchEventsInit();
                showModalBackDrop();
                localeEvents?.localeEventsInit();  // Check if localeEvents exists
                updateArrowVisibility();
                applyLeftNavButtonActiveClass();
                alreadyLoaded=true;
            }else {
                console.log ("Already loaded in openSidebar");
            }
        }
    }

    // Close the sidebar
    async function closeSidebar() {
        const resumeSidebar = document.getElementById('resumeSidebar');
        const dynamicContentArea = document.getElementById('dynamicContentArea');
        var leftSideContainerTop = document.getElementById("leftSideContainerTop");
        if (leftSideContainerTop) leftSideContainerTop.style.visibility = "hidden";
        if (resumeSidebar && dynamicContentArea) {
            resumeSidebar.classList.remove('open');
            // dynamicContentArea.innerHTML = ''; // Clear content when the sidebar is closed
            // leftsidebarpopulate.unload();
            console.log('hiding in closeSidebar');
            hideModalBackDrop();
        }
    }

    // Close sidebar when clicked outside
    async function handleOutsideClick(event) {
        const resumeSidebar = document.getElementById('resumeSidebar');
        const openResumeSidebarBtn = document.getElementById('hamburger-resume');
        if (resumeSidebar && openResumeSidebarBtn && !resumeSidebar.contains(event.target) && !openResumeSidebarBtn.contains(event.target)) {
            closeSidebar();
        }
    }

    // Close sidebar on Escape key press
    async function handleKeyPress(event) {
        const openResumeSidebarBtn = document.getElementById('hamburger-resume');
        if (event.key === "Escape") {
            closeSidebar();
        }

        if (openResumeSidebarBtn && (event.key === "Enter" || event.key === " ") && document.activeElement === openResumeSidebarBtn) {
            openSidebar();
        }
    }

    async function updateArrowVisibility() {
        clearTimeout(arrowVisibilityTimeout); // Clear any previous timeout
        arrowVisibilityTimeout = setCustomTimeout(() => {
            const leftSidebarScrollUpButton = document.getElementById('leftSidebarScrollUp');
            const leftSidebarScrollDownButton = document.getElementById('leftSidebarScrollDown');
            const arrowContainer = document.getElementById('arrowContainer');
            const dynamicContentArea = document.getElementById('dynamicContentArea');

            if (dynamicContentArea && leftSidebarScrollUpButton && leftSidebarScrollDownButton && arrowContainer) {
                const { scrollTop, scrollHeight, clientHeight } = dynamicContentArea;

                if (scrollHeight > clientHeight) {
                    arrowContainer.style.display = 'flex';
                    dynamicContentArea.style.maxHeight = 'calc(100vh - 40px)'; // Adjust height to account for arrows
                } else {
                    arrowContainer.style.display = 'none'; // Hide arrows if no overflow
                    dynamicContentArea.style.maxHeight = '100%'; // Expand to full height if no overflow
                }

                leftSidebarScrollUpButton.disabled = scrollTop === 0;
                leftSidebarScrollDownButton.disabled = scrollTop + clientHeight >= scrollHeight;
            }
        }, 100); // Delay by 200ms
    }

    function resumePageEventsInit() {
        const openResumeSidebarBtn = document.getElementById('hamburger-resume');
        const closeResumeSidebarBtn = document.getElementById('closeResumeSidebar');
        const dynamicContentArea = document.getElementById('dynamicContentArea');
        const leftSidebarScrollUpButton = document.getElementById('leftSidebarScrollUp');
        const leftSidebarScrollDownButton = document.getElementById('leftSidebarScrollDown');

        if (leftSidebarScrollDownButton && dynamicContentArea) {
            leftSidebarScrollDownButton.addEventListener('click', () => {
                if (!leftSidebarScrollDownButton.disabled) {
                    dynamicContentArea.scrollBy({
                        top: 100,
                        behavior: 'smooth'
                    });
                }
            });
        }

        if (leftSidebarScrollUpButton && dynamicContentArea) {
            leftSidebarScrollUpButton.addEventListener('click', () => {
                if (!leftSidebarScrollUpButton.disabled) {
                    dynamicContentArea.scrollBy({
                        top: -100,
                        behavior: 'smooth'
                    });
                }
            });
        }

        if (openResumeSidebarBtn) {
            openResumeSidebarBtn.addEventListener('click', function (event) {
                event.stopImmediatePropagation();
                openSidebar();
            });
        }

        if (closeResumeSidebarBtn) {
            closeResumeSidebarBtn.addEventListener('click', function (event) {
                event.stopImmediatePropagation();
                closeSidebar();
            });
        }

        if (dynamicContentArea) {
            dynamicContentArea.addEventListener('scroll', updateArrowVisibility);
        }

        window.addEventListener('resize', updateArrowVisibility);
        document.addEventListener('keydown', handleKeyPress);
    }

    function unload() {
        // Get references to all DOM elements usedalreadyLoaded
        alreadyLoaded=false;
        const openResumeSidebarBtn = document.getElementById('hamburger-resume');
        const closeResumeSidebarBtn = document.getElementById('closeResumeSidebar');
        const dynamicContentArea = document.getElementById('dynamicContentArea');
        const leftSidebarScrollUpButton = document.getElementById('leftSidebarScrollUp');
        const leftSidebarScrollDownButton = document.getElementById('leftSidebarScrollDown');
        const resumeSidebar = document.getElementById('resumeSidebar');
        const arrowContainer = document.getElementById('arrowContainer');

        // Remove event listeners
        if (openResumeSidebarBtn) {
            openResumeSidebarBtn.removeEventListener('click', openSidebar);
            openResumeSidebarBtn.remove(); // Remove from DOM
        }

        if (closeResumeSidebarBtn) {
            closeResumeSidebarBtn.removeEventListener('click', closeSidebar);
            closeResumeSidebarBtn.remove(); // Remove from DOM
        }

        if (dynamicContentArea) {
            dynamicContentArea.removeEventListener('scroll', updateArrowVisibility);
        }


        window.removeEventListener('resize', updateArrowVisibility);
        document.removeEventListener('keydown', handleKeyPress);


        if (leftSidebarScrollDownButton) {
            leftSidebarScrollDownButton.removeEventListener('click', () => {
                dynamicContentArea.scrollBy({ top: 100, behavior: 'smooth' });
            });
            leftSidebarScrollDownButton.remove(); // Remove from DOM
        }

        if (leftSidebarScrollUpButton) {
            leftSidebarScrollUpButton.removeEventListener('click', () => {
                dynamicContentArea.scrollBy({ top: -100, behavior: 'smooth' });
            });
            leftSidebarScrollUpButton.remove(); // Remove from DOM
        }



        // Cleanup leftsidebarpopulate module
        leftsidebarpopulate.unload();

        if (arrowContainer) {
            while (arrowContainer.firstChild) {
                arrowContainer.firstChild.remove(); // Remove each child node
            }
        }

        if (resumeSidebar) {
            removeAllChildrenAndStyles(resumeSidebar);
        }

        const lsidebar = document.getElementById('leftSidebarScrollableDiv');
        const rrightDrawer = document.getElementById('rightdrawer');

        const topMenuContainer = document.getElementById('top-menu-container');

        if (lsidebar) {
            removeAllChildrenAndStyles(lsidebar);
        }

        if (rrightDrawer) {
            removeAllChildrenAndStyles(rrightDrawer);
        }

        if (topMenuContainer) {
            removeAllChildrenAndStyles(topMenuContainer);
        }

    }


    return {
        closeSidebar,
        openSidebar,
        handleOutsideClick,
        resumePageEventsInit,
        updateArrowVisibility,
        unload
    };
}

export {
    resumePageEvents
};
